export function getEvents(state: any) {
    return state.eventsPage.list.rows;
}

export function getEventsMeta(state: any) {
    return state.eventsPage.list.meta;
}

export function getEventsParams(state: any) {
    return state.eventsPage.listParams;
}

export function getFilterYears(state: any) {
    return state.eventsPage.filters.years;
}

export function hasMoreEvents(state: any) {
    const rows = getEvents(state);
    const meta = getEventsMeta(state);

    return meta.totalSize > rows.length;
}

export function isLoading(state: any) {
    return state.eventsPage.isLoading;
}
